import { ContactLinkFooter } from '@components/branding/contact-link-footer';
import { ImageAssets } from '@models/asset-paths';
import {
    createConfigurationValuesService,
    createTranslationService
} from '@services/factories';
import {
    cacheTranslationLists,
    cacheTranslations
} from '@utils/cache-translations';
import { observer } from 'mobx-react';
import React from 'react';

enum Translations {
    contactLineTemplate = 'contactLineTemplate',
    contactLinkText = 'contactLinkText'
}

enum TranslationObjects {
    contactLines = 'contactLines'
}

const translationContext = 'contactLinkFooter';

const BrandedContactLinkFooter = () => {
    const configurationValuesService = React.useRef(createConfigurationValuesService()).current;
    const translationService = createTranslationService();

    const translations = cacheTranslations(
        translationService,
        Translations,
        translationContext
    );
    const translationLists = cacheTranslationLists(translationService, TranslationObjects, translationContext);
    // check if PUBLIC_URL is needed here for relative sources
    const brandingImageSrc = configurationValuesService.contactLinkFooterUrl;

    return (
        <ContactLinkFooter
            contactLineTemplate={translations.contactLineTemplate}
            contactLinkText={translations.contactLinkText}
            contactLinkTarget={configurationValuesService.supportUrl}
            contactLines={translationLists.contactLines}
            brandingImageSrc={brandingImageSrc}
        />
    );
}

export default observer(BrandedContactLinkFooter);



// WEBPACK FOOTER //
// ./src/containers/branded-contact-link-footer/index.tsx